module.exports = ".boxedLayout {\n  border: 1px solid #ccc; }\n\n:host ::ng-deep .ui-multiselect {\n  /* border: unset !important; */\n  background: unset !important;\n  width: 100%; }\n\n::ng-deep p-multiselect {\n  height: 40px;\n  width: 100%;\n  background: #f4f4f4; }\n\n.headingSection {\n  padding: 10px;\n  background: #f08000;\n  color: #FFF; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.scss
// module id = ./src/app/dashboard/dashboard.component.scss
// module chunks = main